import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Template from "../../components/layouts/Template";
import IdCard from "../../assets/profile/id-card.svg";
import ReferralIcon from "../../assets/profile/referralIcon.svg";
import Redemptionicon from "../../assets/profile/redemptionIcon.svg";
import PersonalDetail from "../../assets/profile/personal-detail.svg";
// import TopUp from "../../assets/profile/top-up.svg";
import Settings from "../../assets/profile/settings.svg";
import Help from "../../assets/profile/help.svg";
import Legal from "../../assets/profile/legal.svg";
import Logout from "../../assets/profile/logout.svg";
import New from "../../assets/profile/New.svg";
import * as ROUTES from "../../constants/routes";
import { LogoutModal } from "../../components/modals/logoutModal";
import { PointsBalanceCard } from "../../components/cards/PointsBalanceCard";

export const ProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const [isLogoutModalVisible, setLogoutModalVisible] = useState(false);

  return (
    <Template page={5}>
      <div className="flex flex-col items-center pb-16 rounded-xl overflow-y-auto">
        <PointsBalanceCard />
        {/* </ShareWrapper> */}

        <div className="flex flex-col gap-[10px] mt-[14px] w-full">
          <button
            onClick={() => navigate(ROUTES.MANAGE_ID_CARDS)}
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
          >
            <img src={IdCard} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Manage ID Cards</p>
          </button>
          <button
            onClick={() => navigate(ROUTES.REDEMPTION_HISTORY)}
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
          >
            <img src={Redemptionicon} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Redemption History</p>
            <img src={New} alt="debit" width={30} height={16} />
          </button>
          <button
            onClick={() => navigate(ROUTES.REFERRAL)}
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
          >
            <img src={ReferralIcon} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Referral</p>
            <img src={New} alt="debit" width={30} height={16} />
          </button>
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
            onClick={() => navigate(ROUTES.PERSONAL_DETAILS)}
          >
            <img src={PersonalDetail} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Personal Details</p>
          </button>
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
            onClick={() => navigate(ROUTES.ACCOUNT_DETAILS)}
          >
            <img src={IdCard} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Account Details</p>
          </button>
          {/* <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
            onClick={() => navigate(ROUTES.TOP_UP_LIMIT)}
          >
            <img src={TopUp} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Transaction Limit</p>
          </button> */}
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
            onClick={() => navigate(ROUTES.APP_SETTINGS)}
          >
            <img src={Settings} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">App Settings</p>
          </button>

          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg"
            onClick={() => navigate(ROUTES.HELP_AND_SUPPORT)}
          >
            <img src={Help} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Help & Support</p>
          </button>
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg"
            onClick={() => navigate(ROUTES.LEGAL)}
          >
            <img src={Legal} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Legal</p>
          </button>
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#760000] backdrop-blur-sm hover:bg-[#bd0b0b] hover:border-[#bd0b0b] focus:ring-[#bd0b0b] rounded-lg"
            onClick={() => setLogoutModalVisible(true)}
          >
            <img src={Logout} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Logout</p>
          </button>
        </div>
        <LogoutModal
          visible={isLogoutModalVisible}
          onCancel={() => setLogoutModalVisible(false)}
          onOk={() => navigate(ROUTES.LOGOUT)}
        />
      </div>
    </Template>
  );
};
